export const hiveCloudLogoUrl = new URL('./assets/hivecloud-logo.png', import.meta.url).href;
